import React from 'react';
import moment from 'moment';
import styles from './RankingsIndexStyles';

const NextRankingPublishDate = ({ date }) => {
  const nextRankingPublishDate = new Date(date);
  const dateString = moment(nextRankingPublishDate).format('MMMM DD');
  return (
    <div className={styles.nextRankingPublishDate}>
      New Rankings will be published on {dateString} at noon (EST)
    </div>
  );
};

export default NextRankingPublishDate;
